import { FacturaWithRelations } from '@/types/invoices/facturaList';

export const facturasListTypes = {
  startLoadingFacturasList: '[FACTURAS_LIST] Start Loading',
  finishLoadingFacturasList: '[FACTURAS_LIST] Finish Loading',
  facturasListLoad: '[FACTURAS_LIST] Load facturas',
  facturasListSetCount: '[FACTURAS_LIST] Set count',
  facturasListSetPage: '[FACTURAS_LIST] Set page',
  facturasListSetDateRange: '[FACTURAS_LIST] Set date range',
  facturasListResetPage: '[FACTURAS_LIST] Reset page',
  facturasListSetFilter: '[FACTURAS_LIST] Set filter',
} as const;

interface StartLoadingFacturasListAction {
  type: typeof facturasListTypes.startLoadingFacturasList;
}

interface FinishLoadingFacturasListAction {
  type: typeof facturasListTypes.finishLoadingFacturasList;
}

interface FacturasListLoadAction {
  type: typeof facturasListTypes.facturasListLoad;
  payload: FacturaWithRelations[];
}

interface FacturasListSetCountAction {
  type: typeof facturasListTypes.facturasListSetCount;
  payload: number;
}

interface FacturasListSetPageAction {
  type: typeof facturasListTypes.facturasListSetPage;
  payload: number;
}

interface FacturasListSetDateRangeAction {
  type: typeof facturasListTypes.facturasListSetDateRange;
  payload: [string, string];
}

interface FacturasListResetPageAction {
  type: typeof facturasListTypes.facturasListResetPage;
}

interface FacturasListSetFilterAction {
  type: typeof facturasListTypes.facturasListSetFilter;
  payload: any[][];
}

export type FacturasListActions =
  | StartLoadingFacturasListAction
  | FinishLoadingFacturasListAction
  | FacturasListLoadAction
  | FacturasListSetCountAction
  | FacturasListSetPageAction
  | FacturasListSetDateRangeAction
  | FacturasListResetPageAction
  | FacturasListSetFilterAction;
